<template>
  <div class="pdf-redacting-sidebar-type">
    <v-radio-group v-model="redactType" hide-details>
      <div
        v-for="option in redactTypeOptionsValues"
        :key="`option-${option}`"
        v-show="option !== REDACT_TYPE_OPTIONS.AI || documentRedactionAiEnabled"
      >
        <app-button
          :data-locator="getDataLocator(option)"
          class="mb-1 d-flex justify-space-between align-center"
          type="ghost"
          style="padding: 10px 12px;"
          @click="$emit('change-redact-type', option)"
        >
          <!-- AI -->
          <template v-if="option === REDACT_TYPE_OPTIONS.AI">
            <img
              :src="getRedactWithProtegeIcon"
              height="20"
              width="20"
              alt="Icon"
            />
            <p class="text--small text--regular mb-0">
              {{ $t('common.PdfRedactingSidebar.redactWithProtege') }}
            </p>
          </template>

          <!-- KEYWORDS -->
          <template v-else-if="option === REDACT_TYPE_OPTIONS.KEYWORDS">
            <app-icon-ds
              icon="file-magnifying-glass"
              weight="fal"
              size="sm"
            />
            <p class="text--small text--regular mb-0">
              {{ $t('common.PdfRedactingSidebar.redactByKeywords') }}
            </p>
          </template>

          <!-- ZONE -->
          <template v-else>
            <img
              class="ml-1"
              :src="getRedactByKeywordsIcon"
              height="18"
              width="18"
              alt="Icon"
            />
            <p class="text--small text--regular mb-0">
              {{ $t('common.PdfRedactingSidebar.redactByZone') }}
            </p>
          </template>
        </app-button>
      </div>

    </v-radio-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { REDACT_TYPE_OPTIONS } from '@/common/utils/redactTypes.ts'

  export default {
    name: 'PdfRedactingSidebarType',
    emits: ['change-redact-type'],
    props: {
      defaultRedactType: {
        required: true,
        validator: (value) => {
          return value === null || typeof value === 'string'
        },
      },
    },
    data () {
      return {
        redactType: null,
        REDACT_TYPE_OPTIONS,
      }
    },
    computed: {
      ...mapGetters('user', ['documentRedactionAiEnabled']),
      redactTypeOptionsValues () {
        return Object.values(REDACT_TYPE_OPTIONS)
      },
      getRedactWithProtegeIcon () {
        return new URL('@/assets/img/redact-by-keywords-ai-no-results.svg', import.meta.url).href
      },
      getRedactByKeywordsIcon () {
        return new URL(`@/assets/img/redact-by-keywords.svg`, import.meta.url).href
      },
    },
    mounted() {
      this.redactType = this.defaultRedactType
    },
    methods: {
      getDataLocator (option) {
        switch (option) {
          case REDACT_TYPE_OPTIONS.AI:
            return 'redact-with-protege-button'
          case REDACT_TYPE_OPTIONS.KEYWORDS:
            return 'redact-using-keywords-button'
          case REDACT_TYPE_OPTIONS.ZONE:
            return 'redact-by-zone-button'
          default:
            return ''
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "vuetify/settings";
  .pdf-redacting-sidebar-type {
    .v-selection-control-group {
      width: 100%;
    }
  }
</style>
